export default "__VITE_ASSET__BGPByDj1__"